import TC from '../../TC';
import WorkLayerManager from './WorkLayerManager';
TC.control = TC.control || {};
TC.control.ListTOC = WorkLayerManager;
const ListTOC = TC.control.ListTOC;
export default ListTOC;